import { AnyAction } from '@reduxjs/toolkit'
import { keyBy } from 'lodash'

import {
  CREATE_NOTIFICATION_SOURCE_SUCCESS,
  DELETE_NOTIFICATION_SOURCE_SUCCESS,
  FETCH_NOTIFICATION_SOURCES_SUCCESS,
  UPDATE_NOTIFICATION_SOURCE_SUCCESS
} from '@/pages/SpaceNotificationSourcesPage/actionTypes'
import { CHANGE_CURRENT_SPACE } from '@/store/actionTypes'

import {
  DELETE_NOTIFICATION_SUCCESS,
  FETCH_NOTIFICATION_SUCCESS,
  FETCH_NOTIFICATIONS_PAGINATED_SUCCESS,
  RECALL_NOTIFICATION_SUCCESS
} from './actionTypes'

type Source = {
  source: string
  display: string
  iconUrl: string
}

type SpacePublisherPageState = {
  notifications: Record<string, any>
  page: { resourceIds: string[]; startIndex: number; totalResults: number }
  results: Record<string, unknown>
  sources: Record<Source['display'], Source>
}

export const initialState: SpacePublisherPageState = {
  notifications: {},
  page: { resourceIds: [], startIndex: 1, totalResults: 0 },
  results: {},
  sources: {}
}

export default (state = initialState, action: AnyAction): SpacePublisherPageState => {
  switch (action.type) {
    case CHANGE_CURRENT_SPACE: {
      return initialState
    }
    case DELETE_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        page: { ...initialState.page },
        notifications: {
          ...state.notifications,
          [action.notificationId]: {
            ...state.notifications[action.notificationId],
            publisher: { ...state.notifications[action.notificationId].publisher, status: 'Deleted' }
          }
        }
      }
    }

    case FETCH_NOTIFICATIONS_PAGINATED_SUCCESS: {
      return {
        ...state,
        notifications: { ...state.notifications, ...keyBy(action.response.resources, 'id') },
        page: {
          resourceIds: action.response.resources.map(({ id }: { id: string }) => id),
          startIndex: action.response.startIndex,
          totalResults: action.response.totalResults
        }
      }
    }

    case FETCH_NOTIFICATION_SUCCESS: {
      return { ...state, notifications: { ...state.notifications, [action.notificationId]: action.response } }
    }

    case FETCH_NOTIFICATION_SOURCES_SUCCESS: {
      return {
        ...state,
        sources: action.response.reduce(
          (
            byId: Record<Source['display'], Source>,
            { iconUrl, source, title }: { source: string; title: string; iconUrl: string }
          ) => {
            if (!title.includes('publisher api connector')) {
              byId[title] = { display: title, iconUrl, source }
            }

            return byId
          },
          {}
        )
      }
    }

    case RECALL_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          [action.notificationId]: {
            ...state.notifications[action.notificationId],
            publisher: { ...state.notifications[action.notificationId].publisher, status: 'Recalled' }
          }
        }
      }
    }

    // TODO: remove once sources are managed individually by resources (e.g. publisher/survey)
    case CREATE_NOTIFICATION_SOURCE_SUCCESS:
    case DELETE_NOTIFICATION_SOURCE_SUCCESS:
    case UPDATE_NOTIFICATION_SOURCE_SUCCESS: {
      return { ...state, sources: {} }
    }

    default: {
      return state
    }
  }
}
